<template>
  <div
    id="select-creative"
  >
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="text-center mt-3">
      <div class="d-flex justify-content-center flex-wrap text-center gap-3">
        <Button
          class="btn btn-color9 mb-3 mb-lg-0"
          @click="handleSelectCreative('list')"
        >
          {{ $t('existing_creatives') }}
        </Button>
        <div class="text-center">
          <Button
            class="btn btn-color10 mb-3 mb-lg-0"
            @click="handleSelectCreative('create')"
          >
            {{ $t('add_new_creative') }}
          </Button>
        </div>
      </div>
      <!-- CREATIVES LIST -->
      <div v-if="openList" class="mt-5 border border-dashed border-color10 p-5">
        <div class="pb-4 d-flex justify-content-center">
          <form class="default-form w-100" @submit.prevent="search">
            <input
              type="text"
              class="form-control form-control w-100"
              :placeholder="$t('name_or_layout')"
              v-model="filters.search"
              @keyup="search"
            />
          </form>
        </div>
        <!-- FILTERS -->
        <p class="fw-bold text-start mb-2"><i class="fa fa-filter me-2"></i>{{ $t('filters') }}</p>
        <div class="d-flex flex-column flex-lg-row gap-3 pb-4 text-start default-form">
          <!-- FILE TYPE: image x HTML5 (only display creatives have both) -->
          <div class="flex-fill" v-if="showFileTypeFilter">
            <label class="form-label fw-bold">{{ $t('creative_file_type') }}</label>
            <select class="form-select" v-model="filters.file_type" @change="search">
              <option value="">{{ $t('all') }}</option>
              <option value="IMAGE">{{ $t('creative_file_type_image') }}</option>
              <option value="HTML5">{{ $t('creative_file_type_html5') }}</option>
            </select>
          </div>
          <div class="flex-fill">
            <label class="form-label fw-bold">{{ $t('creative_created_from') }}</label>
            <input type="date" class="form-control" v-model="filters.created_from" @change="search" />
          </div>
          <div class="flex-fill">
            <label class="form-label fw-bold">{{ $t('creative_created_until') }}</label>
            <input type="date" class="form-control" v-model="filters.created_until" @change="search" />
          </div>
        </div> <!-- END FILTERS -->
        <div v-if="creatives.length === 0 && loader">
          <Loader
            :size="'big'"
          />
        </div>
        <div v-else-if="creatives.length === 0">
          <p>{{ $t('no_creatives_found') }}</p>
        </div>
        <div v-else>
          <div>
            <div
              class="d-flex creative-item p-3 mb-2 flex-wrap align-items-center rounded border"
              :class="{
                'border-2 border-success bg-light-success': checkIfIsSelectedById(creative.id),
                'border-dashed': !checkIfIsSelectedById(creative.id),
                inactive: creative.format === 'YOUTUBE' || creative.sync_error
              }"
              v-for="(creative, index) in creatives"
              :key="index"
              :id="`creative-${index}`"
              @click="handleClick(creative)"
            >
              <div class="col-lg-4">
                <i class="fa fa-code fa-3x text-muted" v-if="isHtml5Creative(creative)"></i>
                <img :src="creative.file" alt="" style="max-width: 100px;" v-else />
              </div>
              <div class="col-lg-6 text-start">
                <p class="mb-0">
                  <span class="badge badge-success me-2" v-if="checkIfIsSelectedById(creative.id)"><i class="fa fa-check"></i> {{ $t('selected2') }}</span>{{ creative.name }}
                </p>
                <!-- Creative that didn't reach the platform (or isn't active there): can't be selected, can only be deleted -->
                <p class="mb-1" v-if="creative.sync_error">
                  <span class="badge bg-danger"><i class="fa fa-warning me-1"></i>{{ $t('creative_sync_error_tag') }}</span>
                </p>
                <p class="mb-0">
                  <span class="badge bg-dark me-1" v-if="creative.file_type === 'HTML5'">HTML5</span>
                  <span class="badge bg-secondary me-1" v-else-if="creative.file_type === 'IMAGE'">{{ $t('creative_file_type_image_short') }}</span>
                  {{ creative.format | formatCreativeFormat }} | <strong>{{ creative.layout }}</strong>
                  <strong v-if="creative.format === 'AUDIO'">{{ creative.duration }} {{ $t('seconds') }}</strong>
                </p>
              </div>
              <div class="col-lg-2 d-flex flex-column gap-2">
                <Button type="button" class="btn btn-xs btn-color10" @click="handleEditCreative(creative)">
                  {{ $t('edit') }}
                </Button>
                <Button type="button" class="btn btn-xs btn-danger" v-if="!creative.in_use" @click="handleExcludeCreative($event, creative)">
                  {{ $t('exclude') }}
                </Button>
              </div>
              <!-- <div class="col-lg-2">
                <Button type="button" class="btn btn-xs btn-color10">
                  {{ checkIfIsSelectedById(creative.id) ? $t('selected2') : $t('select2') }}
                </Button>
              </div> -->
              <b-tooltip :target="`creative-${index}`" :title="$t('creative_has_error')" v-if="creative.sync_error"></b-tooltip>
            </div>
          </div>
          <div class="py-3">
            <b-pagination
              class="custom-pagination"
              v-if="totalPages > 1"
              v-model="page"
              :total-rows="totalItems"
              :per-page="itemsPerPage"
              :loading="loader"
              @input="getCreatives"
              hide-goto-end-buttons
            />
          </div>
          <div class="position-sticky bottom-0 bg-white text-center py-3 border-top z-index-1">
            <Button
              type="button"
              class="btn btn-color10"
              @click="selectCreative"
              :disabled="selectedCreatives.length === 0"
            >
              {{ $t('select2') }} ({{ selectedCreatives.length }})
            </Button>
          </div>
        </div>
      </div><!-- CREATIVES LIST -->
      <!-- CREATE -->
      <div v-if="isNew" class="mt-5 border border-dashed border-color10 p-5">
        <UpsertCreativeForm
          :advertiserId="advertiserId"
          :format="format"
          :hidePreview="hidePreview"
          :show-cancel="true"
          @creative-created="reset"
          @upsert-creative-error="handleError"
          @format-selected="handleFormatSelected"
          @canceled="handleCanceled('')"
        />
      </div><!-- CREATE -->
      <!-- EDIT -->
      <div v-if="isEdit" class="mt-5 border border-dashed border-color10 p-5">
        <UpsertCreativeForm
          v-if="isEdit"
          :advertiserId="advertiserId"
          :creative="selectedCreative"
          :format="selectedCreative.format"
          @creative-updated="handleUpdated"
          @upsert-creative-error="handleError"
          @canceled="handleCanceled('list')"
        />
      </div><!-- EDIT -->
    </div>
    <!-- EXCLUDE CREATIVE MODAL -->
    <b-modal
      id="exclude-creative-modal"
      :modal-class="'default-modal'"
      :hide-footer="true"
    >
      <div class="text-center mt-3">
        <div class="mb-4">
          <i class="fa fa-warning font-size-large text-warning"></i>
        </div>
        <h2>
          <span>{{ $t('delete_creative') }}</span>
        </h2>
        <p v-html="$t(isLocalOnlyExclusion ? 'exclude_creative_local_only_warning' : 'exclude_creative_warning', { name: creativeToExclude ? creativeToExclude.name : '' })"></p>
        <div class="d-flex justify-content-center gap-3 mt-4">
          <Button type="button" class="btn btn-color9" @click="$bvModal.hide('exclude-creative-modal')">
            {{ $t('cancel') }}
          </Button>
          <Button type="button" class="btn btn-danger" :loading="loader" @click="confirmExcludeCreative">
            {{ $t('exclude') }}
          </Button>
        </div>
      </div>
    </b-modal> <!-- END EXCLUDE CREATIVE MODAL -->
  </div>
</template>

<script>

// import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import CreativesService from '@/modules/creatives/services/creatives-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import UpsertCreativeForm from '@/components/creatives/UpsertCreativeForm'

export default {
  name: 'SelectCreative',
  props: ['advertiserId', 'format', 'isSingleSelect', 'layout', 'hidePreview'],
  components: {
    AlertWraper,
    Button,
    Loader,
    UpsertCreativeForm
  },
  data () {
    return {
      loader: false,
      creatives: [],
      content: null,
      content_type: 'error',
      filters: {
        search: '',
        created_from: '',
        created_until: '',
        file_type: ''
      },
      isEdit: false,
      page: 1,
      creativeToExclude: null,
      selectedCreative: '',
      selectedCreatives: [],
      selectedFormat: '',
      throttleSearch: null,
      isNew: false,
      openList: false,
      to: 9,
      totalItems: 0,
      totalPages: 0
    }
  },
  created () {
    this.getCreatives()
  },
  watch: {
    /**
     * Creative Format
     *
     * @param newVal
     * @param oldVal
     */
    format (newVal, oldVal) {
      if (newVal) this.getCreatives()
    },
    /**
     * advertiserId
     *
     * @param newVal
     * @param oldVal
     */
    advertiserId (newVal, oldVal) {
      if (newVal) this.getCreatives()
    }
  },
  computed: {
    /**
     * The file type filter (image x HTML5) only makes sense for display creatives
     */
    showFileTypeFilter () {
      return !this.format || this.format === 'DISPLAY'
    },
    /**
     * The creative being excluded never reached the platform (sync error without google_id):
     * it exists only on our database, so only it is deleted
     */
    isLocalOnlyExclusion () {
      const creative = this.creativeToExclude
      return !!creative && !!creative.sync_error && !creative.google_id
    }
  },
  methods: {
    /**
     * Check if the creative file is an HTML5 bundle (stored as .zip), which has no image to preview
     */
    isHtml5Creative (creative) {
      return /\.zip$/i.test(creative.file || '')
    },
    /**
     * Check if creative is selected
     */
    checkIfIsSelectedById (id) {
      const index = this.selectedCreatives.findIndex(item => {
        return id === item.id
      })
      return index >= 0
    },
    /**
     * Get creatives
     */
    async getCreatives () {
      if (!this.advertiserId) return
      this.loader = true
      try {
        const creatives = await CreativesService.getCreatives({
          advertiserId: this.advertiserId,
          format: this.format,
          page: this.page,
          search: this.filters.search,
          createdFrom: this.filters.created_from,
          createdUntil: this.filters.created_until,
          fileType: this.filters.file_type,
          layout: this.layout,
          approved_status: this.format === 'YOUTUBE' ? 'PENDING_CREATION' : ''
        })
        this.totalItems = creatives.meta.total
        this.totalPages = creatives.meta.last_page
        this.itemsPerPage = creatives.meta.per_page
        this.from = creatives.meta.from
        this.to = creatives.meta.to
        this.creatives = creatives.data.filter(creative => {
          return creative.layout !== '301x301' // display layout 301x301 audio only
        })
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * Handle canceled
     */
    handleCanceled (type) {
      if (!type) {
        this.isEdit = false
        this.isNew = false
        this.openList = false
      }
      this.handleSelectCreative(type)
    },
    /**
     * Handle click
     */
    handleClick (creative) {
      if (creative.sync_error) return
      if (this.isSingleSelect && this.selectedCreatives.length >= 1) return
      // Check if there already is selected
      const index = this.selectedCreatives.findIndex(item => {
        return creative.id === item.id
      })
      if (index < 0) {
        // If isnt selected, add to array
        this.selectedCreatives.push(Object.assign({}, creative))
      } else {
        // Remove from array if is selected
        this.selectedCreatives.splice(index, 1)
      }
    },
    /**
     * Exclude creative: opens the confirmation modal
     */
    handleExcludeCreative (event, creative) {
      event.stopPropagation()
      this.creativeToExclude = creative
      this.$bvModal.show('exclude-creative-modal')
    },
    /**
     * Confirm exclusion: deletes the creative on the backend
     */
    async confirmExcludeCreative () {
      const creative = this.creativeToExclude
      if (!creative) return
      this.loader = true
      try {
        await CreativesService.destroyCreative(creative.id)
        this.creatives = this.creatives.filter(item => item.id !== creative.id)
        this.selectedCreatives = this.selectedCreatives.filter(item => item.id !== creative.id)
        this.$emit('creative-excluded', creative)
        this.content = null
        NotificationService.createGlobalSuccessQuickNotification(this.$t('creative_excluded_successfully'))
      } catch (error) {
        this.content_type = 'error'
        this.content = parseErrorResponseToArray(error)
      } finally {
        this.loader = false
        this.creativeToExclude = null
        this.$bvModal.hide('exclude-creative-modal')
      }
    },
    handleEditCreative (creative) {
      this.selectedCreative = ''
      this.openList = false
      this.isEdit = true
      this.selectedCreative = creative
    },
    /**
     * Handle error
     */
    handleError (error) {
      this.content = parseErrorResponseToArray(error)
    },
    /**
     * Handle format selected
     */
    handleFormatSelected (format) {
      this.selectedFormat = format
    },
    handleSelectCreative (value) {
      if (value === 'list') {
        this.isEdit = false
        this.isNew = false
        this.openList = true
      }
      if (value === 'create') {
        this.isEdit = false
        this.openList = false
        this.isNew = true
      }
    },
    /**
     * Handle updated
     */
    handleUpdated (creative) {
      this.isEdit = false
      // this.localCreative = creative
      this.content = null
    },
    /**
     * Hidden
     */
    hidden () {
      this.creatives = []
      this.page = 1
      this.selectedCreatives = []
      this.selectedFormat = ''
      this.content = null
    },
    /**
     * Load more
     */
    loadMore () {
      this.page++
      this.getCreatives()
    },
    /**
     * Reset
     */
    reset () {
      this.creatives = []
      this.page = 1
      this.selectedCreatives = []
      this.selectedFormat = ''
      this.handleSelectCreative('list')
      this.getCreatives()
    },
    /**
     * Search creatives
     */
    search () {
      clearTimeout(this.throttleSearch)
      this.page = 1
      this.throttleSearch = setTimeout(this.searchCreatives, 500)
    },
    /**
     * Get creatives for search
     */
    searchCreatives () {
      this.creatives = []
      this.getCreatives()
    },
    /**
     * Select creative
     */
    selectCreative () {
      if (this.selectedCreatives.length === 0) return
      this.$emit('creative-selected', this.selectedCreatives)
      this.openList = false
    },
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
.creative-item:hover {
  cursor: pointer;
  background: #eee;
}
.creative-item.inactive {
  background: #eee;
  opacity: 0.3;
}
</style>
